import React, {useState, useEffect} from 'react';

const ShowLeftEar = (props) => {
    const [state, setState] = useState();
    useEffect(() => {
        if (props.data && props.data.LeftEar && props.data.LeftEar.isLeftEar === 'Yes') {
            setState(props.data.LeftEar);
            
        }
    }, [props.data]);
    return (
        <React.Fragment>
            {state && <> 
            <h3>Left Ear</h3><ul className='showHstory'>
                {Object.entries(state).map(([key, value]) => {
                    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                        Object.entries(value).map(([key_inner, value_inner]) => {
                            return <li>{key_inner} : <strong>{value_inner}</strong></li>
                        });
                    } else if (Array.isArray(value)) {
                            return <li>{key} : <strong>{value.join()}</strong></li>
                    } else {
                            return <li>{key} : <strong>{value}</strong></li>
                    }
                }) }
            </ul></> }           
        </React.Fragment>
    );
}

export default ShowLeftEar;
